<div class="modal-container-cancel">
    <p class="title u-mb-2">Cancelar subida de facturas</p>
    <p class="body">¿Estás seguro de cancelar la subida de facturas?</p>
    <p class="body">Perderás todo tu progreso.</p>
    <div class="d-flex button-container-cancel">
      <div (click)="confirm()" class="button-cancel delete-button">Sí, cancelar</div>
      <div (click)="cancel()" class="button-cancel accept-button">Continuar editando</div>
    </div>
  </div>
  